import axiosInstance from "../axios/axios-instance";
import { pathAPI } from "../utils/pathApi";

// Response interfaces matching backend API
export interface PendingReview {
  id: number;
  review_text: string;
  score_outlet: number;
  score_service: number;
  score_stylist: number;
  reviewer_name: string;
  salon_name: string;
  outlet_id: number;
  review_date: string;
  moderation_status: string;
  created_date: string;
}

export interface ModerationActionResponse {
  review_id: number;
  moderation_status: string;
  is_visible: boolean;
  moderated_by: number;
  moderated_date: string;
  moderation_note: string;
  message: string;
}

export interface ModerationActionRequest {
  approved: boolean;
  note?: string;
}

// RestPagingResponse structure from CommonRestResponseAdvice
// Pagination fields are at the same level as success/code/data
export interface RestPagingResponse<T> {
  success: boolean;
  code: string;
  message?: string;
  data: T[];              // Direct array, not {content: [...]}
  currentPage: number;    // camelCase field names
  perPage: number;
  total: number;          // Use 'total', not 'total_elements'
  totalPage: number;
  lastPage: number;
  from: number;
  to: number;
}

export const ReviewModerationService = {
  /**
   * Get pending reviews with pagination
   */
  getPendingReviews: (page: number = 0, size: number = 20) => {
    return axiosInstance.get<RestPagingResponse<PendingReview>>(
      pathAPI.reviewsPending,
      { params: { page, size } }
    );
  },

  moderateReview: (reviewId: number, request: ModerationActionRequest) => {
    return axiosInstance.post<ModerationActionResponse>(
      pathAPI.reviewsModerate.replace(":reviewId", reviewId.toString()),
      request
    );
  },

  /**
   * Approve a review
   */
  approveReview: (reviewId: number, note: string = "") => {
    return ReviewModerationService.moderateReview(reviewId, {
      approved: true,
      note,
    });
  },

  /**
   * Reject a review
   */
  rejectReview: (reviewId: number, note: string) => {
    return ReviewModerationService.moderateReview(reviewId, {
      approved: false,
      note,
    });
  },
};
